module.exports = __webpack_public_path__ + "static/media/47.058f212c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/47.png
// module id = 471
// module chunks = 0